module.exports['abs'] = require('./abs')
module.exports['frexp'] = require('./frexp')
